import { MULTIPLE_ROOMS } from '../constants';

const initialState = {
  isCheckingExtras: false,
  extrasByRoomSelected: {
    [MULTIPLE_ROOMS.FIRST]: null,
    [MULTIPLE_ROOMS.SECOND]: null,
    [MULTIPLE_ROOMS.THIRD]: null,
    [MULTIPLE_ROOMS.FOURTH]: null,
  },
  extrasAvailId: {
    [MULTIPLE_ROOMS.FIRST]: null,
    [MULTIPLE_ROOMS.SECOND]: null,
    [MULTIPLE_ROOMS.THIRD]: null,
    [MULTIPLE_ROOMS.FOURTH]: null,
  },
};

// eslint-disable-next-line default-param-last
export const extras = (state = initialState, action) => {
  switch (action.type) {
    case 'IS_CHECKING_EXTRAS':
      return { ...state, isCheckingExtras: action.isCheckingExtras };
    case 'SET_EXTRAS_AVAIL_ID':
      return { ...state, extrasAvailId: action.availId };
    case 'SET_EXTRAS_BY_ROOM_SELECTED':
      return { ...state, extrasByRoomSelected: action.extrasByRoom };
    default:
      return state;
  }
};
